import {
    doLogout,
    fetchAdmin,
    createAdmin,
    updateAdmin,
    deleteAdmin
} from '../api/admin'
import {
    LOGOUT,
    FETCH_ADMIN,
    CREATE_ADMIN,
    UPDATE_ADMIN,
    DELETE_ADMIN,
} from "../mutation-types"

const AUTHORIZED   = 'authorized'
const UNAUTHORIZED = 'unauthorized'

// initial state
const admin = {
    namespace: 'admin',
    state: {
        all: [],
        status: 'unauthorized',
        last_sync: false,
        details: {
            id: 0,
            first_name: '',
            last_name: '',
            email: '',
            role: 'User',
        }
    },
    getters: {
        auth: (state) => state.status === AUTHORIZED,
        admins: (state) => state.all,
        admin: (state) => state.details,
        isSuperUser: (state) => state.details.role === 'Admin',
    },
    mutations: {

        [LOGOUT]: (state) => {
            state.status                  = UNAUTHORIZED
            window.document.location.href = '/login'
        },

        [FETCH_ADMIN]: (state, data) => {
            state.status = AUTHORIZED
            for (let field in data) {
                if (state.details.hasOwnProperty(field)) {
                    state.details[field] = data[field]
                }
            }
            state.last_sync = Date.now()
        },

        [CREATE_ADMIN]: (state, data) => {
            state.all.push(data)
        },

        [UPDATE_ADMIN]: (state, data) => {
            let updateAdmin = state.all.find(admin => admin.id === data.id);
            let updateIndex = state.all.indexOf(updateAdmin)

            state.all.splice(updateIndex, 1, data)

            if (state.details.id === data.id) {
                for (let field in data) {
                    if (state.details.hasOwnProperty(field)) {
                        state.details[field] = data[field]
                    }
                }
            }
        },

        [DELETE_ADMIN]: (state, data) => {
            let deleteAdmin = state.all.find(admin => admin.id === data.id);
            let deleteIndex = state.all.indexOf(deleteAdmin)

            state.all.splice(deleteIndex, 1)
        },
    },

    actions: {

        [LOGOUT]: ({commit, dispatch, state}) => {
            return new Promise((resolve, reject) => {
                doLogout(commit)
                    .then(data => {
                        commit(LOGOUT, data)
                        resolve(data)
                    })
                    .catch(errors => {
                        reject(errors)
                    })
            })
        },

        [FETCH_ADMIN]: ({commit, dispatch, state}) => {
            return new Promise((resolve, reject) => {

                // now get the server data and wait for the response to sync the user's session
                fetchAdmin(commit)
                    .then(data => {
                        if (data === false) {
                            window.document.location.href = '/login'
                            return reject(data)
                        }
                        commit(FETCH_ADMIN, data)
                        resolve(data)
                    })
                    .catch(errors => {
                        window.document.location.href = '/login'
                        reject(errors)
                    })
            })
        },

        [CREATE_ADMIN]: ({commit, dispatch, state}, data) => {
            return new Promise((resolve, reject) => {
                createAdmin(commit, data.fields)
                    .then(data => {
                        commit(CREATE_ADMIN, data)
                        resolve(data)
                    })
                    .catch(errors => {
                        reject(errors)
                    })
            })
        },

        [UPDATE_ADMIN]: ({commit, dispatch, state}, data) => {
            return new Promise((resolve, reject) => {
                updateAdmin(commit, data.fields)
                    .then(data => {
                        commit(UPDATE_ADMIN, data)
                        resolve(data)
                    })
                    .catch(errors => {
                        reject(errors)
                    })
            })
        },

        [DELETE_ADMIN]: ({commit, dispatch, state}, data) => {
            return new Promise((resolve, reject) => {
                deleteAdmin(commit, data)
                    .then(data => {
                        commit(DELETE_ADMIN, data)
                        resolve(data)
                    })
                    .catch(errors => {
                        reject(errors)
                    })
            })
        },

    },
};

export default admin;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/admin/index.js
// module id = 601
// module chunks = 0